// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportForm__form-ce6525 {
  flex: 1;
  overflow: auto;
  padding: 24px;
}

.ReportForm__title-b9f4cd {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.ReportForm__comment-c0b92e {
  margin-top: 24px;
}

.ReportForm__loader-cde250 {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/ReportForm/ReportForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":[".form {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n\n.title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.comment {\n  margin-top: 24px;\n}\n\n.loader {\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `ReportForm__form-ce6525`,
	"title": `ReportForm__title-b9f4cd`,
	"comment": `ReportForm__comment-c0b92e`,
	"loader": `ReportForm__loader-cde250`
};
module.exports = ___CSS_LOADER_EXPORT___;
